module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Astronomic coordinates","hourAngle":"Hour angle","sunElevation":"Elevation (zenith angle &theta; and elevation angle &alpha;)","sunAzimuth":"Azimuth angle"},"ru":{"title":"Положение солнца в локальных координатах","hourAngle":"Часовой угол","sunElevation":"Высота (угол зенита &theta; и высота &alpha;)","sunAzimuth":"Азимут"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/localcoordinates.vue
// module id = 733
// module chunks = 0